import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'

import FlagCountry from '~/components/FlagCountry'
import countriesEn from '~/const/countries-en.json'

const countriesTranslations: Record<string, string> = countriesEn

import './styles.scss'

const CountryCellRenderer = ({ value }: ICellRendererParams): ReactElement => {
  return (
    <div className="country-cell">
      {value ? <FlagCountry countryCode={value} countryLabel={countriesTranslations[value] || value} /> : null}
    </div>
  )
}

export default CountryCellRenderer
